import { BarDataset } from './BarDataset';
export class BarData {
  public labels = new Array<any>();
  public datasets = new Array<BarDataset>();
}
